import { defaultMeta } from '@/constants/defaultMeta';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { customerWithdrawalsQueries } from '@/services/withdrawals/customerWithdrawals.queries';
import { StatusType } from '@/services/withdrawals/withdrawals.types';
import { useSearch } from '@tanstack/react-router';

const useParams = () => {
  const search = useSearch({ from: '/(app)/configuration-management/withdrawals-setup/' });
  const { page, fetch, sort, q } = search;
  return {
    row: page,
    fetch: fetch ?? 10,
    sort,
    search: q,
  };
};

export const useCustomerWithdrawalList = (type: StatusType, enabled: boolean) => {
  const { sort, ...params } = useParams();

  const { data, isFetched, isLoading } = useQuery({
    ...customerWithdrawalsQueries.list(type, params),
    enabled,
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return {
    customerWithdrawals: data?.data || [],
    isFetched,
    loading: isLoading,
    pagination: data?.meta?.pagination ?? defaultMeta,
  };
};

export const useCustomerWithdrawalDetail = (withdrawalId?: string) => {
  const { data, isLoading } = useQuery({
    ...customerWithdrawalsQueries.detail(withdrawalId),
    enabled: Boolean(withdrawalId),
  });

  return { withdrawalDetail: data?.data, isLoading };
};
